import React from 'react'
import PropTypes from 'prop-types'
import Style from './style'

const defaultList = []
const defaultFunction = () => { }

class TimePicker extends React.Component {
  constructor(props) {
    super(props)
    this.hourSection = React.createRef()
    this.minuteSection = React.createRef()
    this.scrollTimer1 = null
    this.scrollTimer2 = null
    props = Object.assign({}, props)
    props.selectedDate = props.selectedDate != null ? props.selectedDate : new Date()
    this.selectedYear = props.selectedDate.getFullYear()
    this.selectedMonth = props.selectedDate.getMonth()
    this.selectedDate = props.selectedDate.getDate()
    this.minuteStep = props.minuteStep ? props.minuteStep : 15
    if (props.selectTime) {
      this.minute = this.getNearestMinute(props.selectTime.getMinutes())
      this.hour = props.selectTime.getHours()
      if (this.minute >= 60) {
        this.minute = 0
        this.hour = this.hour + 1
      }
    } else {
      this.minute = null
      this.hour = null
    }

    this.state = {
      doReRender: false
    }

    let minute = 0
    let hour = 0
    if (props.startSelectable != null) {
      minute = this.getNearestMinute(props.startSelectable.getMinutes())
      hour = props.startSelectable.getHours()
      if (minute >= 60) {
        minute = 0
        hour = hour + 1
      }
      this.startSelectableHour = new Date(props.startSelectable.getFullYear(), props.startSelectable.getMonth(), props.startSelectable.getDate(), hour, 0)
      this.startSelectableMinute = new Date(props.startSelectable.getFullYear(), props.startSelectable.getMonth(), props.startSelectable.getDate(), hour, minute)
    }

    if (props.endSelectable != null) {
      minute = this.getNearestMinute(props.endSelectable.getMinutes())
      hour = props.endSelectable.getHours()
      if (minute >= 60) {
        minute = 0
        hour = hour + 1
      }
      this.endSelectableHour = new Date(props.endSelectable.getFullYear(), props.endSelectable.getMonth(), props.endSelectable.getDate(), hour, 0)
      this.endSelectableMinute = new Date(props.endSelectable.getFullYear(), props.endSelectable.getMonth(), props.endSelectable.getDate(), hour, minute)
    }
  }

  validateData () {
    if (this.minute == null || this.hour == null) return false
    return true
  }

  animateProp1 (element, propertyName, newValue, duration, framerate, delay = 0) {
    if (element == null) return false
    const oldValue = element[propertyName]
    const stepTime = (1 / framerate) * 1000
    const maxStepCount = duration / stepTime
    const stepValue = (newValue - oldValue) / maxStepCount
    const countTimer = 0
    if (this.scrollTimer1 != null) clearTimeout(this.scrollTimer1)
    this.scrollTimer1 = setTimeout(() => this.doAnimation1(element, propertyName, oldValue + stepValue, newValue, countTimer, maxStepCount, stepValue, stepTime), stepTime + delay)
  }

  doAnimation1 (element, propertyName, value, maxValue, count, maxCount, stepValue, stepTime) {
    element[propertyName] = value
    count = count + 1
    if (count > maxCount) {
      this.scrollTimer1 = null
      return null
    } else if (count >= maxCount) {
      this.scrollTimer1 = setTimeout(() => this.doAnimation1(element, propertyName, maxValue, maxValue, count, maxCount, stepValue, stepTime), stepTime)
    } else {
      this.scrollTimer1 = setTimeout(() => this.doAnimation1(element, propertyName, value + stepValue, maxValue, count, maxCount, stepValue, stepTime), stepTime)
    }
  }

  animateProp2 (element, propertyName, newValue, duration, framerate, delay = 0) {
    if (element == null) return false
    const oldValue = element[propertyName]
    const stepTime = (1 / framerate) * 1000
    const maxStepCount = duration / stepTime
    const stepValue = (newValue - oldValue) / maxStepCount
    const countTimer = 0
    if (this.scrollTimer2 != null) clearTimeout(this.scrollTimer2)
    this.scrollTimer2 = setTimeout(() => this.doAnimation2(element, propertyName, oldValue + stepValue, newValue, countTimer, maxStepCount, stepValue, stepTime), stepTime + delay)
  }

  doAnimation2 (element, propertyName, value, maxValue, count, maxCount, stepValue, stepTime) {
    element[propertyName] = Math.round(value)
    count = count + 1
    if (count > maxCount) {
      this.scrollTimer2 = null
      return null
    } else if (count >= maxCount) {
      this.scrollTimer2 = setTimeout(() => this.doAnimation2(element, propertyName, maxValue, maxValue, count, maxCount, stepValue, stepTime), stepTime)
    } else {
      this.scrollTimer2 = setTimeout(() => this.doAnimation2(element, propertyName, value + stepValue, maxValue, count, maxCount, stepValue, stepTime), stepTime)
    }
  }

  range (start, end, step = 1) {
    const result = []
    for (let i = start; i < end; i += step) {
      result.push(i)
    }
    return result
  }

  getMinutes (doReRender, disabledList = defaultList) {
  // getMinutes (doReRender) {
    const minuteStep = this.minuteStep
    const minuteMark = this.range(0, 60, minuteStep)
    setTimeout(() => this.animateProp2(this.minuteSection.current, 'scrollTop', Math.floor(this.minute * 50 / minuteStep), 300, 60), 0)

    return minuteMark.map((minute, index) => {
      let className = 'timeButton'
      let disabled = false

      const minuteObject = new Date(this.selectedYear, this.selectedMonth, this.selectedDate, this.hour, minute)
      const minuteStart = this.startSelectableMinute
      const minuteEnd = this.endSelectableMinute

      const isDisabledMinuteStart = minuteStart && minuteStart > minuteObject
      const isDisabledMinuteEnd = minuteEnd && minuteEnd < minuteObject

      const isDisabledHours = isDisabledMinuteStart || isDisabledMinuteEnd || disabledList.includes(minute)
      if (isDisabledHours) {
        disabled = true
      }

      // Don't remove this code it's backup
      // const { startOperatingTime, endOperatingTime } = this.props
      // const [hourStartOperation, minuteStartOperation] = startOperatingTime.split(':')
      // const [hourEndOperation, minuteEndOperation] = endOperatingTime.split(':')

      // const isBelow = minute < minuteStartOperation
      // if (Number(hourStartOperation) === this.hour && isBelow) {
      //   disabled = true
      // }

      // const isOver = minute >= minuteEndOperation
      // if (Number(hourEndOperation) === this.hour && isOver) {
      //   disabled = true
      // }

      if (this.minute === minute) {
        className = className.concat(' selectTime')
      }

      return (
        <button
          key={minute}
          value={minute}
          className={className}
          disabled={disabled}
          onClick={() => this.handleButtonClickMinute(this.minuteSection, index)}
        >
          <h1>{minute.toString().padStart(2, '0')}</h1>
        </button>
      )
    })
  }

  getHours (disabledList = defaultList) {
    // getHours () {
    const hourMark = this.range(0, 24)
    setTimeout(() => this.animateProp1(this.hourSection.current, 'scrollTop', this.hour * 50, 300, 60), 0)

    return hourMark.map((hour, index) => {
      let className = 'timeButton'
      let disabled = false

      const hourObject = new Date(this.selectedYear, this.selectedMonth, this.selectedDate, hour, 0)
      const hourStart = this.startSelectableHour
      const hourEnd = this.endSelectableHour

      const isDisabledHourStart = hourStart && hourStart > hourObject
      const isDisabledHourEnd = hourEnd && hourEnd < hourObject

      const isDisabledHours = isDisabledHourStart || isDisabledHourEnd || disabledList.includes(hour)
      if (isDisabledHours) {
        disabled = true
      }

      // Don't remove this code it's backup
      // const { startOperatingTime, endOperatingTime } = this.props
      // const hourStartOperation = startOperatingTime.substr(0, 2)
      // let [hourEndOperation, minuteEndOperation] = endOperatingTime.split(':')

      // const isMinuteZero = minuteEndOperation === '00'
      // if (isMinuteZero) {
      //   hourEndOperation -= 1
      // }

      // const isDisabledHours = (hour < hourStartOperation) || (hour > hourEndOperation)
      // if (isDisabledHours) {
      //   disabled = true
      // }

      if (this.hour === hour) {
        className = className.concat(' selectTime')
      }

      return (
        <button
          key={hour}
          value={hour}
          className={className}
          disabled={disabled}
          onClick={() => this.handleButtonClickHour(this.hourSection, index)}
        >
          <h1>{hour.toString().padStart(2, '0')}</h1>
        </button>
      )
    })
  }

  handleUpButtonHour () {
    this.handleButtonClickHour(this.hourSection, this.hour - 1)
  }

  handleUpButtonMinute () {
    this.handleButtonClickMinute(this.minuteSection, Math.round(this.minute / this.minuteStep) - 1)
  }

  handleDownButtonHour () {
    this.handleButtonClickHour(this.hourSection, this.hour + 1)
  }

  handleDownButtonMinute () {
    this.handleButtonClickMinute(this.minuteSection, Math.round(this.minute / this.minuteStep) + 1)
  }

  handleButtonClickHour (section, index) {
    const selectedNode = this.getSelectedNode(section, index)
    if (selectedNode.value == null || selectedNode.disabled) return null
    this.resetselectTime(section)
    this.hour = parseInt(selectedNode.value)
    selectedNode.classList.toggle('selectTime', true)
    this.setState({
      doReRender: !this.state.doReRender
    })
    this.minute = null
  }

  handleButtonClickMinute (section, index) {
    const selectedNode = this.getSelectedNode(section, index)
    if (selectedNode.value == null || selectedNode.disabled) return null
    this.resetselectTime(section)
    this.minute = parseInt(selectedNode.value)
    selectedNode.classList.toggle('selectTime', true)
    this.setState({
      doReRender: !this.state.doReRender
    })
  }

  setScrollPosition (section, value) {
    if (section.current == null) return null
    section.current.scrollTop = value
  }

  getNearestMinute (value, mode = 2) {
    const minuteStep = this.minuteStep
    const leftOver = value % minuteStep
    switch (mode) {
      case 1:
        if (minuteStep - leftOver < Math.floor(minuteStep / 2)) {
          value = value + minuteStep - leftOver
        } else {
          value = value - leftOver
        }
        return value
      default:
        if (leftOver === 0) return value
        return value + minuteStep - leftOver
    }
  }

  getNearestScrollPos (section, value) {
    let index = Math.floor(value / 50)
    const offset = value % 50
    if (offset >= 25) index += 1
    return index * 50
  }

  getSelectedNode (section, index) {
    return section.current.childNodes[index + 1]
  }

  resetselectTime (section) {
    const selectTimeNode = Object.values(section.current.childNodes).filter((node) => node.classList.length > 1)
    selectTimeNode.map((node) => node.classList.toggle('selectTime', false))
  }

  render () {
    const props = Object.assign({}, this.props)
    const validationResult = this.validateData()
    return (
      <Style colorTheme={props.colorTheme}>
        <section className='timePicker jump-in'>
          <section className='timeHeader'>
            <h1>{props.language === 'TH' ? 'ชั่วโมง' : 'Hour'}</h1>
            <h1>{props.language === 'TH' ? 'นาที' : 'Minute'}</h1>
          </section>
          <section className='timeField'>
            <section className='hourField'>
              <button className='timeArrow upsideDown' onClick={() => this.handleUpButtonHour()}>
                <svg
                  aria-hidden='true'
                  focusable='false'
                  data-prefix='fas'
                  data-icon='caret-down'
                  role='img'
                  xmlns='http://www.w3.org/2000/svg'
                  viewBox='0 0 320 512'
                >
                  <path
                    fill='currentColor'
                    d='M31.3 192h257.3c17.8 0 26.7 21.5 14.1 34.1L174.1 354.8c-7.8 7.8-20.5 7.8-28.3 0L17.2 226.1C4.6 213.5 13.5 192 31.3 192z'
                  />
                </svg>
              </button>
              <section className='hourSection' ref={this.hourSection}>
                <div className='spaceAdder' />
                {this.getHours(props.disabledHour ? props.disabledHour : defaultList)}
                <div className='spaceAdder' />
              </section>
              <button className='timeArrow' onClick={() => this.handleDownButtonHour()}>
                <svg
                  aria-hidden='true'
                  focusable='false'
                  data-prefix='fas'
                  data-icon='caret-down'
                  role='img'
                  xmlns='http://www.w3.org/2000/svg'
                  viewBox='0 0 320 512'
                >
                  <path
                    fill='currentColor'
                    d='M31.3 192h257.3c17.8 0 26.7 21.5 14.1 34.1L174.1 354.8c-7.8 7.8-20.5 7.8-28.3 0L17.2 226.1C4.6 213.5 13.5 192 31.3 192z'
                  />
                </svg>
              </button>
            </section>
            <section className='minuteField'>
              <button className='timeArrow upsideDown' onClick={() => this.handleUpButtonMinute()}>
                <svg
                  aria-hidden='true'
                  focusable='false'
                  data-prefix='fas'
                  data-icon='caret-down'
                  role='img'
                  xmlns='http://www.w3.org/2000/svg'
                  viewBox='0 0 320 512'
                >
                  <path
                    fill='currentColor'
                    d='M31.3 192h257.3c17.8 0 26.7 21.5 14.1 34.1L174.1 354.8c-7.8 7.8-20.5 7.8-28.3 0L17.2 226.1C4.6 213.5 13.5 192 31.3 192z'
                  />
                </svg>
              </button>
              <section className='minuteSection' ref={this.minuteSection}>
                <div className='spaceAdder' />
                {this.getMinutes(this.state.doReRender, props.disabledMinute && props.disabledMinute[this.hour] ? props.disabledMinute[this.hour] : defaultList)}
                <div className='spaceAdder' />
              </section>
              <button className='timeArrow' onClick={() => this.handleDownButtonMinute()}>
                <svg
                  aria-hidden='true'
                  focusable='false'
                  data-prefix='fas'
                  data-icon='caret-down'
                  role='img'
                  xmlns='http://www.w3.org/2000/svg'
                  viewBox='0 0 320 512'
                >
                  <path
                    fill='currentColor'
                    d='M31.3 192h257.3c17.8 0 26.7 21.5 14.1 34.1L174.1 354.8c-7.8 7.8-20.5 7.8-28.3 0L17.2 226.1C4.6 213.5 13.5 192 31.3 192z'
                  />
                </svg>
              </button>
            </section>
          </section>
          <hr className='lightLine' />
          <section className='timeButtons'>
            <button className='closeButton' onClick={(event) => props.handleCloseButton(event)}><h3>{props.language === 'TH' ? 'กลับ' : 'Close'}</h3></button>
            <button disabled={!validationResult} className={validationResult ? 'saveButton' : 'saveButtonDisable'} onClick={validationResult ? (event) => props.handleSaveButton(event, new Date(this.selectedYear, this.selectedMonth, this.selectedDate, this.hour, this.minute)) : defaultFunction}><h3>{props.language === 'TH' ? 'บันทึก' : 'Save'}</h3></button>
          </section>
        </section>
      </Style>
    )
  }
}

TimePicker.defaultProps = {
  startOperatingTime: '00:00:00',
  endOperatingTime: '23:59:00',
}

TimePicker.propTypes = {
  selectedDate: PropTypes.instanceOf(Date),
  selectedTime: PropTypes.instanceOf(Date),
  startSelectable: PropTypes.instanceOf(Date),
  endSelectable: PropTypes.instanceOf(Date),
  minuteStep: PropTypes.number,
  disabledHour: PropTypes.array,
  disabledMinute: PropTypes.shape(),
  handleSaveButton: PropTypes.func.isRequired,
  handleCloseButton: PropTypes.func.isRequired,
  isShowing: PropTypes.bool,
  startOperatingTime: PropTypes.string,
  endOperatingTime: PropTypes.string,
}

export default TimePicker
